import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponseMessage, IUser } from '../../models';
import { APIConstants } from '../../common';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient) { }

  getAllUsers(): Observable<IUser[]> {
    return this.http.get<IUser[]>(APIConstants.users);
  }

  addUser(user: FormData): Observable<IResponseMessage> {
    return this.http.post<IResponseMessage>(APIConstants.users, user);
  }

  updateUser(user_id: number, user: FormData): Observable<IResponseMessage> {
    return this.http.put<IResponseMessage>(APIConstants.users + user_id + '/', user);
  }

  deleteUserById(user_id: number): Observable<IResponseMessage> {
    return this.http.delete<IResponseMessage>(APIConstants.users + user_id + '/');
  }

  deleteUserProfile(): Observable<IResponseMessage> {
    return this.http.delete<IResponseMessage>(APIConstants.profile);
  }

}
